<template>
  <div>
    <CModal
      :show.sync="isShowModal"
      :close-on-backdrop="false"
      :color="modalColor"
      size="lg"
    >
      <template #header>
        <h6 class="modal-title">{{ modalTitle }}</h6>
        <CButtonClose
          @click="notificationModalCallBack(false)"
          class="text-black"
        />
      </template>
      <template #footer>
        <CRow class="w-100 align-items-center">
          <!-- Left group -->
          <CCol
            cols="12"
            md="6"
            class="mb-2 mb-md-0 d-flex justify-content-start"
          >
            <CButton
              color="primary"
              class="btn-responsive"
              @click="showAssessmentResults = true"
            >
              Previous Result
            </CButton>
          </CCol>

          <!-- Right group -->
          <CCol
            cols="12"
            md="6"
            class="d-flex justify-content-start justify-content-end"
          >
            <div class="d-flex flex-column flex-md-row w-md-auto">
              <CButton
                color="primary"
                class="btn-responsive mb-2 mb-md-0"
                @click="navigateToAssessment()"
              >
                Take the FREE test now
              </CButton>
              <CButton
                class="btn-responsive ml-md-2"
                color="secondary"
                @click="notificationModalCallBack(false)"
              >
                Cancel
              </CButton>
            </div>
          </CCol>
        </CRow>
      </template>
      <div>
        <p>
          Our <b>FREE English</b> language assessment will allow you to
          understand your current ability and if needed, we can recommend
          suitable English language training to assist you to obtain a necessary
          level for a particular region/country.
        </p>
        <p>
          You can log your assessment or final results and allow them to be
          viewed by healthcare recruiters. If the recruiters select you for
          interview, they will already know the status of your English language
          level and may offer you funding to support your language studies.
        </p>
        <!-- <p>Please select from the following options:</p> -->
        <!-- <CRow>
          <CCol md="6">
            <RadioButton
              name="take_test"
              :value="assessment_test.take_test"
              :options="(options && options['assessmentTest']) || []"
              :vertically="true"
              @change="handleChangeRadioCustom"
            />
          </CCol>
        </CRow> -->
      </div>
    </CModal>
    <AssessmentResult
      v-if="showAssessmentResults"
      @closeModal="showAssessmentResults = false"
    />
  </div>
</template>
<script>
import RadioButton from "@/components/reusable/Fields/RadioButton";
import AssessmentResult from "../../../pages/Assessment/AssessmentResult.vue";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "AssessmentModal",
  props: {
    isShowModal: {
      type: Boolean,
      default: false,
    },
    modalColor: {
      type: String,
      default: "primary",
    },
    modalTitle: {
      type: String,
      default: "NOTIFICATION",
    },
  },
  components: {
    RadioButton,
    AssessmentResult,
  },
  data() {
    return {
      assessment_test: {},
      showAssessmentResults: false,
    };
  },
  computed: {
    ...mapGetters(["getAssessmentTestId"]),
    options() {
      return {
        assessmentTest: [
          { code: 1, label: "Take the FREE test now" },
          { code: 2, label: "Take the FREE test later" },
          { code: 3, label: "I don’t want to take the test" },
        ],
      };
    },
  },
  methods: {
    ...mapActions(["createTestAssessmentId"]),
    notificationModalCallBack(action) {
      this.$emit("modalCallBack", action);
      this.showAssessmentResults = false;
    },
    handleChangeRadioCustom(name, value) {
      Vue.set(this.assessment_test, name, value);
    },
    async navigateToAssessment() {
      await this.createTestAssessmentId();
      if (!this.getAssessmentTestId.completed) {
        this.$router.push(
          `/assessment/${this.getAssessmentTestId?.assessment_test_id}`
        );
      } else {
        this.$emit("closeModal", false);
      }
    },
  },
};
</script>
